import { initialize } from "@stories-js/core/components";
/**
 * We need to make sure that the web component fires an event
 * that will not conflict with the user's @stories-change binding,
 * otherwise the binding's callback will fire before any
 * v-model values have been updated.
 */
const toKebabCase = (eventName) => eventName === "stories-change"
    ? "v-stories-change"
    : eventName.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
const getHelperFunctions = () => {
    return {
        ael: (el, eventName, cb, opts) => el.addEventListener(toKebabCase(eventName), cb, opts),
        rel: (el, eventName, cb, opts) => el.removeEventListener(toKebabCase(eventName), cb, opts),
        ce: (eventName, opts) => new CustomEvent(toKebabCase(eventName), opts),
    };
};
export const StoriesVue = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async install(_) {
        if (typeof window !== "undefined") {
            const { ael, rel, ce } = getHelperFunctions();
            initialize({
                _ael: ael,
                _rel: rel,
                _ce: ce,
            });
        }
    },
};
//# sourceMappingURL=stories-vue.js.map